
import { gql } from "@apollo/client";



const VEH_ROUTE_LIST_PART = gql`
fragment VehRouteListPart on VehRoute {
    routeSeq
    comId
    custId
    vehId
    gpsDatetime
    gpsTime
    vehInfoSeq
    vehPlates
    vehAlias
    devId
    termId
    recvTime
    insertTime
    xDist
    yDist
    location
    speed
    distKm
    direction
    statusCode
    eventCd
    svcCondCd
    loadCondCd
    gpioBits
    pwrType
    posSys
    lat
    lon
    cycleMake
    cycleReport
    custPoiCode
    doorEvent
    door0
    door1
    door2
    tempr1
    tempr2
    tempr3
    tempr4
    itinRepType
    irLat
    irLon
    irYCoord
    irXCoord
    midRoute
}
`;
/*
    irDist
    irMins
    irPoiType
    irPoiSeq
    irAction
    addrPrefix
    poiName
    poiDistM
    roadName
    roadRank
    roadMaxSpeed
*/

// vehRouteList(vehInfoSeq:Int!, timeFrom:String!, timeTill:String!): [VehRoute]!

export const LIST_VEH_ROUTE = gql`
${VEH_ROUTE_LIST_PART}
query ListVehRoute($vehInfoSeq:Int!, $timeFrom:String!, $timeTill:String!) {
    vehRouteList(vehInfoSeq:$vehInfoSeq, timeFrom:$timeFrom, timeTill:$timeTill) {
        ...VehRouteListPart
    }
}
`;